import {Button, Checkbox, Flex, Select} from "antd";
import React from "react";
import "./index.style.scss";
import RoomCount from "./filters/RoomCount";
import NumberRangeSelector from "./filters/SizeRange";
import translate from "../../i18n/translate";
import {LOCALES} from "../../i18n";
import SaleRoomCount from "./filters/SaleRoomCount";
const { Option } = Select;

function ReloadOutlined() {
    return null;
}

export default function  Filters({ searchParams, setSearchParams, filterType,setSmallChess, smallChess,propertyType,setPropertyType ,syncSheets, excludeSmoke, setExcludeSmoke, showFavorites, setShowFavorites, userData}) {
  return (
    <div className="filter-container">

        <Select
            value={propertyType}
            style={{ width: '100%', marginBottom: 20 }}
            onChange={(value) => setPropertyType(value)}
        >
            <Option value="apartment">
                {translate("menu.apartments")}
            </Option>
            <Option value="office">
                {translate("menu.office")}
            </Option>
            <Option value="parking">
                {translate("menu.parking")}
            </Option>
            <Option value="storage-room">
                {translate("menu.storage_room")}
            </Option>
        </Select>



        <Select
            value={smallChess}
            style={{ width: "100%" ,marginBottom:20}}
            onChange={(value) => setSmallChess(value)}
        >
            <Option value={false}> {translate("chess.big")}</Option>
            <Option value={true}> {translate("chess.small")}</Option>
        </Select>
      <br />
      <h1>{translate('filter.title')}</h1>
      {filterType !== "all" && (
        <>
          <div className="filter-card">
            <p>{translate("filter.floors")} {searchParams.floor}-{translate("filter.floor_suffix")} </p>
            <div className="buttons">
              {[2, 3, 4, 5, 6, 7, 8, 9, 10].map((floor) => (
                <Button
                    key={floor}
                    className={"green-btn"}
                  ghost={floor == searchParams.floor}
                  onClick={() => setSearchParams({ ...searchParams, floor })}
                >
                  {floor}-{translate("filter.floor_suffix")}
                </Button>
              ))}
            </div>
          </div>
          <div className="filter-card">
            <p>
              {translate("filter.buildings")}{" "}
              {searchParams.block === "all"
                ? translate("filter.all_buildings")
                : `${["", "A", "B", "C", "D"][searchParams.block]} ${translate("filter.building")}`}
            </p>
            <div className="buttons">
              {[1, 2, 3, 4].map((block) => (
                <Button
                    key={block}
                    className={"green-btn"}
                  ghost={block == searchParams.block}
                  onClick={() => setSearchParams({ ...searchParams, block })}
                >
                  {["", "A", "B", "C", "D"][block]} {translate("filter.building")}
                </Button>
              ))}
              <Button
                className={'green-btn-fill'}
                ghost={searchParams.block === "all"}
                onClick={() =>
                  setSearchParams({ ...searchParams, block: "all" })
                }
              >
                {translate("filter.all_buildings")}
              </Button>
            </div>
          </div>
        </>
      )}
      <NumberRangeSelector
        setSearchParams={setSearchParams}
        searchParams={searchParams}
      />{" "}

        <div className="filter-card">
            <p>{translate("filter.status")}</p>
            <Select
                value={searchParams.status || "all"}
                style={{ width: "100%" }}
                onChange={(value) => setSearchParams({ ...searchParams, status: value === "all" ? undefined : value })}
            >
                <Option value="all">{translate("filter.all_status")}</Option>
                <Option value="sold">{translate("status.sold")}</Option>
                {(propertyType === "apartment" || propertyType === "office") && (
                    <>
                        <Option value="reserved">{translate("status.booked")}</Option>
                        <Option value="reserved_paid">{translate("status.reserved_paid")}</Option>
                        <Option value="not_full_paid">{translate("status.not_paid")}</Option>
                    </>
                )}
            </Select>
        </div>

        {
            (propertyType=== "apartment" || propertyType === "office") &&
<>
      <RoomCount
        setSearchParams={setSearchParams}
        searchParams={searchParams}
      />
        <SaleRoomCount
            setSearchParams={setSearchParams}
            searchParams={searchParams}
        />
    {/*{*/}
    {/*    propertyType === "apartment" &&*/}
    {/*    <div style={{ marginTop: 16 }}>*/}
    {/*        <Checkbox*/}
    {/*            checked={excludeSmoke}*/}
    {/*            onChange={(e) => setExcludeSmoke(e.target.checked)}*/}
    {/*        >*/}
    {/*            {translate("filter.exclude_smoke")}*/}
    {/*        </Checkbox>*/}
    {/*    </div>*/}
    {/*}*/}
</>
        }
        {userData?.id && (
            <div style={{ marginTop: 16 }}>
                <Checkbox
                    checked={showFavorites}
                    onChange={(e) => setShowFavorites(e.target.checked)}
                >
                    {translate("filter.show_favorites")}
                </Checkbox>
            </div>
        )}
      <Flex justify="end">
        <Button
          onClick={() =>
            setSearchParams({
              ...searchParams,
              minArea: 0,
              maxArea: 350,
              roomCount: "1+,2+,3+",
                saleRoomCount:"",
                status: undefined
            })
          }
        >
          {translate("filter.clear")}
        </Button>
      </Flex>
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
}
